import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import clsx from 'clsx';
import styles from './Section.module.css';

type Props = {
    variant?: 'default' | 'outlined' | 'filled';
    size?: 'm' | 'l';
    block?: boolean;
    noPadding?: boolean;
} & PickProps<'div', 'ref' | 'children'>;

export const Section: FC<Props> = ({ variant = 'default', size = 'm', block, noPadding, children, ...props }) => (
    <section
        className={clsx(styles.section, styles[`variant-${variant}`], styles[`size-${size}`], block && styles.block, noPadding && styles.noPadding)}
        {...props}
    >
        {children}
    </section>
);
